import { EPatientStatusNumeric } from '@mybonum/api';

import { TPatientType } from './types';

export const MOCK_PATIENTS: TPatientType[] = [
    {
        id: 101,
        firstName: 'John',
        lastName: 'Williams',
        email: 'john.williams@example.com',
        createdDate: '2025-09-23 09:13:21',
        birthdate: '1987-04-15',
        gender: 'Male',
        primaryLanguage: 'English',
        secondaryLanguage: 'Spanish',
        status: EPatientStatusNumeric.Active,
    },
    {
        id: 102,
        firstName: 'Emily',
        lastName: 'Davis',
        email: 'emily.davis@example.com',
        createdDate: '2025-09-24 12:34:45',
        birthdate: '1992-10-02',
        gender: 'Female',
        primaryLanguage: 'English',
        secondaryLanguage: '-',
        status: EPatientStatusNumeric.Active,
    },
    {
        id: 103,
        firstName: 'Michael',
        lastName: 'Johnson',
        email: 'michael.johnson@example.com',
        createdDate: '2025-09-25 15:45:00',
        birthdate: '1985-02-08',
        gender: 'Male',
        primaryLanguage: 'English',
        secondaryLanguage: 'French',
        status: EPatientStatusNumeric.Inactive,
    },
    {
        id: 104,
        firstName: 'Sophia',
        lastName: 'Martinez',
        email: 'sophia.martinez@example.com',
        createdDate: '2025-09-26 14:27:12',
        birthdate: '1990-06-22',
        gender: 'Female',
        primaryLanguage: 'Spanish',
        secondaryLanguage: 'English',
        status: EPatientStatusNumeric.Active,
    },
    {
        id: 105,
        firstName: 'James',
        lastName: 'Brown',
        email: 'james.brown@example.com',
        createdDate: '2025-09-27 17:18:33',
        birthdate: '1979-01-30',
        gender: 'Male',
        primaryLanguage: 'English',
        secondaryLanguage: '-',
        status: EPatientStatusNumeric.Active,
    },
    {
        id: 106,
        firstName: 'Ava',
        lastName: 'Wilson',
        email: 'ava.wilson@example.com',
        createdDate: '2025-09-28 10:56:44',
        birthdate: '1994-08-19',
        gender: 'Female',
        primaryLanguage: 'English',
        secondaryLanguage: 'Chinese',
        status: EPatientStatusNumeric.Inactive,
    },
    {
        id: 107,
        firstName: 'William',
        lastName: 'Moore',
        email: 'william.moore@example.com',
        createdDate: '2025-09-29 11:22:39',
        birthdate: '1982-11-14',
        gender: 'Male',
        primaryLanguage: 'English',
        secondaryLanguage: 'Portuguese',
        status: EPatientStatusNumeric.Active,
    },
    {
        id: 108,
        firstName: 'Isabella',
        lastName: 'Taylor',
        email: 'isabella.taylor@example.com',
        createdDate: '2025-09-30 08:40:20',
        birthdate: '1996-03-28',
        gender: 'Female',
        primaryLanguage: 'English',
        secondaryLanguage: '-',
        status: EPatientStatusNumeric.Active,
    },
    {
        id: 109,
        firstName: 'Benjamin',
        lastName: 'Clark',
        email: 'benjamin.clark@example.com',
        createdDate: '2025-10-01 19:07:15',
        birthdate: '1989-07-05',
        gender: 'Male',
        primaryLanguage: 'English',
        secondaryLanguage: 'Japanese',
        status: EPatientStatusNumeric.Active,
    },
    {
        id: 110,
        firstName: 'Mia',
        lastName: 'Lewis',
        email: 'mia.lewis@example.com',
        createdDate: '2025-10-02 13:52:28',
        birthdate: '1993-05-11',
        gender: 'Female',
        primaryLanguage: 'English',
        secondaryLanguage: '-',
        status: EPatientStatusNumeric.Inactive,
    },
];
